import React,{useState, useEffect, useCallback} from "react";
import useTspData from "./data-fetch/fetch-combined-cluster-reports";
// import useClusterInsightsData from "./data-fetch/clusterInsights";
import ScaleLoaderItem from "../../Ui-Elemnent/ScaleLoader";
// import FilterComponent from "../FilterComponent";
import {CSVLink} from 'react-csv'
import DateRangeSelector from '../../Ui-Elemnent/DateRange'
import format from 'date-fns/format';
import { useNavigate } from "react-router-dom";
import CalenderSelctor from "../../Ui-Elemnent/Calender";
import { DropDown } from "../../Ui-Elemnent/DropDown";

const rowHeading = [{heading:"Ward No.", key:'wardNumber',  isChecked:true}, {heading:"total TSP", key: 'totalNumberOfTSP' , isChecked:true}, {heading:"Cleaned TSP", key: 'noOfTSPCleaned', isChecked:true},{heading:"Cleaned TSP %", key: 'percentageOfBinCleanup', isChecked:true}, {heading:"Segregation %",key: 'percentageOfSegregation', isChecked:true}, {heading:"Non-Segregation %",key: 'percentageOfNonSegregation', isChecked:true}]


export default function Table({city,  skip, limit, setTotalCount, range, setRange}:{city:string, skip:number, limit:number, setTotalCount:any, range:any, setRange:any}) {
    const navigate = useNavigate();
     ////// Date Range Selector
     const today = new Date()
     
     const [calendar, setCalendar] = useState<any>(today);
     const [selectdDate, setSelectedDate] = useState(format(new Date(), "dd/MM/yyyy"));
     const [toDate, setToDate] = useState<string>(format(new Date(), "yyyy-MM-dd"));
     const [fromDate, setFormDate] = useState<string>(format(new Date(), "yyyy-MM-dd"));
     const [dayDiff, setDaydiff] =useState<any>();
      
     useEffect(()=>{
        setSelectedDate(format(new Date(calendar), "dd/MM/yyyy"))
     },[calendar])
     ///////////////
    
    useEffect(()=>{

        setToDate(format(range[0].endDate, "yyyy-MM-dd"))
        setFormDate(format(range[0].startDate, "yyyy-MM-dd"))

        setDaydiff((range[0].endDate - range[0].startDate) / 86400000);

    },[range, toDate, fromDate]);

    const {clustersData,tspCount, loading} = useTspData({city:city, toDate:toDate,fromDate:fromDate, setTotalCount:setTotalCount});
    const tspData = clustersData;
    const tspCountData = tspCount;
    console.log("tspData",tspData);
    const [openFilter, setOpenFilter] = useState<boolean>(false)
    const [tspList, setTspList] = useState<any[]>([]);
    const [searchText, setSearchText] = useState<string>('');
    const [data, setData] = useState<any[]>([]);
    const [filteredColumn, setFilteredColumn] = useState<any[]>([]);

    // Filter Status
     const options = ["All","Scanned", "Un-Scanned", "UnAssignScanned"];
    const [selectedStatus, setSelectedStatus] = useState(options[0])

    ///
    // Filter Data According to status
    useEffect(()=>{
        if(selectedStatus=== "Scanned"){
            let tempData = tspData.filter((item)=> item.scanStatus === "Yes");
            setTotalCount(tempData.length)
            setData(tempData)
        }
        if(selectedStatus=== "Un-Scanned"){
            let tempData = tspData.filter((item)=> item.scanStatus === "No");
            setTotalCount(tempData.length)
            setData(tempData)
        }
        if(selectedStatus=== "UnAssignScanned"){
            let tempData = tspData.filter((item)=>item.scanStatus === "Yes" && item?.assignWW !== item?.scannedWW);
            setTotalCount(tempData.length)
            setData(tempData)
        }
        if(selectedStatus=== "All"){
            setTotalCount(tspData.length)
            setData(tspData)
        }
    },[selectedStatus])
    
    useEffect(()=>{
        setSelectedStatus("All");
        // setTotalCount(tspData.length)
    },[city, selectdDate])
    type Data = typeof tspData;
    type SortKey =  keyof Data[0];
    type SortOrder = 'ascn' | 'desc'
    useEffect(()=>{
        setData(tspData)
        
    },[ tspData])

// const rowHeading = [{heading:"Ward No.", key:'wardNumber',  isChecked:true}, {heading:"total TSP", key: 'totalNumberOfTSP' , isChecked:true}, {heading:"Cleaned TSP", key: 'noOfTSPCleaned', isChecked:true},{heading:"BinCleanup%", key: 'percentageOfBinCleanup', isChecked:true}, {heading:"Segregation%",key: 'percentageOfSegregation', isChecked:true}, {heading:"NonSegregation%",key: 'percentageOfNonSegregation', isChecked:true}]
    const headers = [{label:"Ward No.", key:'wardNumber',  }, {label:"total TSP", key: 'totalNumberOfTSP' , }, {label:"Cleaned TSP", key: 'noOfTSPCleaned', },{label:"Cleaned TSP %", key: 'percentageOfBinCleanup', }, {label:"Segregation %",key: 'percentageOfSegregation', }, {label:"Non-Segregation %",key: 'percentageOfNonSegregation', }];
    // const headers = [{label:"Ward No.", key:'wardNumber',  }, {label:"totalNumberOfTSP", key: 'totalNumberOfTSP' , }, {label:"Scan Status", key: 'scanStatus', },{label:"Area/Location Name", key: 'areaName', }, {label:"Assigned WW",key: 'assignWW', }, {label:"Assigned WW Name",key: 'name', }, {label:"Scanned WW", key: 'scannedWW',}];
      useEffect(()=>{
        setFilteredColumn(rowHeading);
      },[rowHeading]);

   // sorting functionality
    const [sortKey, setSortKey] = useState<SortKey>('');
    const [sortOrder, setSortOrder] = useState<SortOrder>('desc');
   
    
      function sortData({tableData, sortKey, reverse}:{tableData:Data, sortKey:SortKey, reverse:boolean}){
    //    console.log("sortKey", sortKey);
       
        if(!sortKey) return tableData
      
       const sortedData =  tableData.sort((a, b) => 
       {if(sortKey === 'wardNo'){
        return Number(a[sortKey] ) > Number(b[sortKey]) ? 1 :-1
       }
        return a[sortKey] > b[sortKey] ? 1 :-1}
       )

       if(reverse){ return sortedData.reverse()}
        return sortedData
      }

      const sortedData = useCallback(()=>sortData({tableData: tspData, sortKey, reverse : sortOrder === 'desc'}),[tspData, sortKey, sortOrder])

      ///
      useEffect(()=>{
        setData(sortedData())
    },[sortedData]);

      useEffect(()=>{
        setTspList(data.slice(skip, (skip + limit)))
    },[skip, limit, data, sortedData]);
    
    

    const handleChange = ( value:string)=>{
        setSearchText(value)
           
         }   

        useEffect(()=>{
            filterData(searchText)
        },[searchText])

    const filterData = (value:string)=>{
        const lowerCaseValue =  value.toLowerCase().trim();
        // console.log("lowerCaseValue",lowerCaseValue);
        
        if(!lowerCaseValue){
            setData(sortedData())
        }else {
            const filteredData = sortedData().filter(item =>{
                // console.log("item", item)
                return Object.keys(item).some(key =>{
                   
                    return item[key].toString().toLowerCase().includes(lowerCaseValue)
                })
            });
            // console.log("filteredData",filteredData);
            
            setData(filteredData)
            // console.log(data);
            
        }
    } 
        const handleSortClick = (sortKey:string)=>{
            setSortOrder(sortOrder === 'ascn'? 'desc':'ascn')
            setSortKey(sortKey)
            // console.log(sortKey);
        }
        
       
return (
        <div className="flex flex-col">
            <div className="overflow-x-auto ">
                <div className="flex justify-start py-3 pl-2 ">

                    <div className='flex justify-end  '>
                    {/* <div style={{ marginRight: "6px" }}> */}
                        { <DateRangeSelector range={range} setRange={setRange}  />}
                    {/* <div/> */}
                    {/* {<CalenderSelctor calendar={calendar} setCalendar={setCalendar} />} */}
                    {/* {<FilterComponent options={options} selected={selectedStatus} setSelected={setSelectedStatus} />} */}

                    <div className="flex items-center border border-gray rounded-md mr-4 h-12">
                        <CSVLink data={tspList?.length !== 0 && data !== undefined ? data : ''} filename={`Tsp_Report_${city}_${selectedStatus}_${selectdDate}`} headers={headers}>
                            <button className="relative z-0 inline-flex text-sm rounded-md shadow-sm focus:ring-accent-500 focus:border-accent-500 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1" >
                                <span className="relative inline-flex items-center px-3 py-3 space-x-2 text-sm font-medium text-gray-600 bg-white  rounded-md sm:py-2">
                                    <div>
                                    <svg className="w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                                    </svg>
                                    </div>
                                    <div className="hidden sm:block">
                                        Download    
                                    </div>
                                </span>
                            </button>
                        </CSVLink>
                    </div>
                </div>



                </div>
                {/* <div className="absolute justify-center z-20 ">
                    {openFilter && <FilterComponent options={options} selected={selected} setSelected={setSelected} />}
                </div> */}
                <div className="">
                    <TspCollectionSheet totalCount={tspCountData} />
                </div>
                <div className="p-1.5 w-full inline-block align-middle">
                    <div className="overflow-hidden border rounded-lg">
                    {loading ? <ScaleLoaderItem loading={loading}/> :
                    
                        <table className="min-w-full divide-y divide-recity">
                            <thead className="bg-recity">
                                <tr>
                                    {
                                        filteredColumn.map((item, index) =>{
                                            return(
                                                <th key={index}
                                                    scope="col"
                                                    className="px-4 py-2 text-l font-bold text-center text-white uppercase "
                                                    onClick={e=>handleSortClick(item.key)}
                                                >
                                                    {item.isChecked &&  item.heading }
                                                </th>
                                            )
                                        })
                                    }
                                </tr>
                            </thead>
                           
                            <tbody className="divide-y divide-gray-200">
                                {
                                    tspList.map((item, index)=>{
                                        
                                        return(
                                            <tr key={index}>
                                                      
                                            {/* <td className="py-2 text-md text-recity whitespace-nowrap underline">
                                               <button className="font-bold">

                                                {filteredColumn[0].isChecked && item?.wardNumber}
                                               </button>
                                               
                                            </td> */}

                                            <td className="py-2 text-md text-recity whitespace-nowrap underline">
                                                {filteredColumn[0].isChecked && (
                                                <button
                                                    onClick={() =>
                                                    navigate(
                                                        `/fleet/ward/${item?.wardNumber}?toDate=${toDate}&city=${"Ponda"}`
                                                    )
                                                    }
                                                    className="font-bold text-blue-600 hover:text-blue-800"
                                                >
                                                    {item?.wardNumber}
                                                </button>
                                                )}
                                            </td>

                                            <td className=" py-2 text-sm text-gray-800 whitespace-nowrap">
                                            {filteredColumn[1].isChecked && item?.totalNumberOfTSP}
                                            </td>
                                            <td className="py-2 text-sm text-gray-800 whitespace-nowrap">
                                               {filteredColumn[2].isChecked && item.noOfTSPCleaned}
                                            </td>
                                            <td className="py-2 text-sm text-gray-800 whitespace-nowrap">
                                               
                                               {filteredColumn[3].isChecked && item?.percentageOfBinCleanup}
                                           
                                            </td>
                                            <td className="py-2 text-sm text-gray-800 whitespace-nowrap">
                                               
                                               {filteredColumn[3].isChecked && item?.percentageOfSegregation}
                                           
                                            </td>
                                            <td className="py-2 text-sm text-gray-800 whitespace-nowrap">
                                               
                                               {filteredColumn[4].isChecked && item?.percentageOfNonSegregation}
                                           
                                            </td>
                                            {/* <td className="py-2 text-sm text-gray-800 whitespace-nowrap">
                                               
                                               {filteredColumn[4].isChecked && item?.scanned_cluster?.[0]?.username }
                                           
                                            </td> */}
                                        </tr>
                                        )
                                    })
                                }
                          
                            </tbody>
                        </table>
                }
                    </div>
                </div>

            </div>
        </div>
    );
}


function TspCollectionSheet({totalCount}:{totalCount:any}){
    return(
      <div className="grid grid-cols-4 gap-8 m-4 w-3/4">
        <div className="bg-sky-50  rounded rounded-lg p-2 text-start">
          <div className=" text-sm">Total Tsp</div>
          <div className='text-3xl font-500'> {totalCount?.totalTsp}</div>
        </div>
        
        <div className="bg-sky-50  rounded rounded-lg p-2 text-start">
          <div className=" text-sm">Scanned %</div>
          <div className='text-3xl font-500'> {totalCount?.scannedTsp}</div>
        </div>
        <div className="bg-sky-50  rounded rounded-lg p-2 text-start">
          <div className=" text-sm">Unscanned %</div>
          <div className='text-3xl font-500'> {totalCount?.unscannedTsp}</div>
        </div>
  
      </div>
    )
  }

  const FilterComponent = ({options, selected, setSelected}:{options:string[], selected:string, setSelected:any })=>{
    // const options = ["All","Scaned", "Un-Scaned", "UnAssignScaned"];
    // const [selected, setSelected] = useState(options[0])
    return(

        <div className="z-2 mx-2">
            <DropDown list={options} setSelected={setSelected} selected={selected}/>
        </div>
    )
  }